/*
 * Die Pfade des Anmeldewegs — Routen des GO-SERVERS, nicht dieser SPA.
 *
 * ═══ Warum das eine eigene Datei ist ══════════════════════════════════════
 *
 * `/auth/login` stand nach dem siebten Durchgang als Literal an DREI Stellen
 * (`Tabelle.tsx`, `Navigation.tsx`, `AnmeldeSeite.tsx`) und war damit Punkt 20
 * der offenen Liste. Drei Literale sind nicht schlimm; drei Literale, von
 * denen eines beim nächsten Umbau übersehen wird, sind es sehr wohl.
 *
 * ═══ Warum hier ein `<a href>` steht und kein Router-`Link` ═══════════════
 *
 * Diese Pfade gehören dem Go-Server (`internal/api/auth.go`, `PathAuthLogin`).
 * Ein Router-`Link` navigierte clientseitig, fände im Routenbaum nichts und
 * erreichte die Anmeldung nie — es braucht die VOLL-Navigation. Genau diese
 * Absicht brach fünf Durchgänge lang in der Entwicklungsumgebung, weil
 * `vite.config.ts` nur `/api` proxied hat und Vite `/auth/login` mit seiner
 * eigenen `index.html` beantwortete.
 *
 * `lib/server-pfade.test.ts` hält jede Konstante dieser Datei gegen die
 * Proxy-Tabelle aus `dev-proxy.ts` und gegen den Routenbaum. Sie ist damit die
 * QUELLE für diesen Test und keine zweite Liste daneben.
 *
 * ═══ Was hier NICHT steht ════════════════════════════════════════════════
 *
 * `/auth/logout` und `/auth/callback`. Beide kennt der Server, beide stehen in
 * `schema.d.ts`.
 *
 * `/auth/callback` springt MICROSOFT an — kein Knopf dieser SPA zeigt je
 * darauf.
 *
 * `/auth/logout` hat seit Punkt 19 einen Aufrufer, und trotzdem KEINE
 * Konstante hier. Frühere Fassungen dieses Absatzes haben eine angekündigt;
 * gemessen wäre sie eine Verschlechterung:
 *
 *   - Der Pfad geht nicht durch ein `href`, sondern durch den TYPISIERTEN
 *     Client (`api.POST` in `api/auth.ts`) — der Server verlangt POST, damit
 *     ein fremder Link niemanden abmelden kann. Damit hält ihn der Compiler
 *     gegen die Spec, und das ist die stärkere Zusage als jede Konstante.
 *     Genau das fehlt `/auth/login`, das in einem `href` steht — deshalb gibt
 *     es `PFAD_ANMELDEN` und deshalb nur den.
 *   - `lib/stoerungstexte.test.ts` liest die Endpunkte eines api-Moduls per
 *     Textscan auf den Aufruf. Hinter einer Konstanten wäre dieser Aufruf für
 *     ihn unsichtbar — dieselbe Klasse wie der Umzug, der im achten Durchgang
 *     einem Wächter seine Quelle entzogen hat.
 *
 * Ungeprüft sind beide trotzdem nicht: `server-pfade.test.ts` leitet sie aus
 * dem Spec-Tag `Auth` ab und prüft sie mit — dieselbe Sache, aus der
 * richtigen Quelle.
 */

/**
 * Der Einstieg in den Anmeldeweg.
 *
 * Gegenstück zu `PathAuthLogin` in `internal/api/auth.go`.
 */
export const PFAD_ANMELDEN = "/auth/login";

/**
 * Das Ziel des Anmelde-Knopfs, mit durchgereichtem Rücksprung.
 *
 * ═══ Warum hier NICHT gehärtet wird ═══════════════════════════════════════
 *
 * `callbackUrl` kommt aus der URL und ist damit fremder Text. Gehärtet wird er
 * trotzdem erst im Go-Server (`auth.SicheresZiel`, nur eigene Pfade) — und das
 * ist kein Versäumnis, sondern die richtige Reihenfolge: eine zweite
 * Härtungsregel in der SPA wäre eine zweite Fassung derselben Zusage, die von
 * der ersten abweichen kann. Der Server MUSS prüfen, weil der Wert ihn auch
 * ohne diese Seite erreicht (getippte Adresse, altes Lesezeichen).
 *
 * Ein offener Redirect entsteht hier nicht: das gebaute Ziel ist immer
 * `/auth/login…` und damit dieselbe Origin, egal was in `callbackUrl` steht.
 */
export function anmeldeZiel(callbackUrl: string | undefined): string {
  if (callbackUrl === undefined || callbackUrl === "") return PFAD_ANMELDEN;
  return `${PFAD_ANMELDEN}?${new URLSearchParams({ callbackUrl }).toString()}`;
}
